import { Record } from 'immutable';

export default Record({
    body: null,
    expiresAt: null,
    id: null,
    imageUrl: null,
    linkText: null,
    title: null,
    type: null,
    url: null,
});
